import * as React from 'react';

import AdminSyncTypeSpreadsheetView from 'admin/rostering/components/AdminSyncTypeSpreadsheetView';
import AdminSyncTypeCleverView from 'admin/rostering/components/AdminSyncTypeCleverView';
import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import Container from 'components/Container';
import CurrentUser from 'auth/CurrentUser';
import Dialog from 'components/Dialog';
import Heading from 'components/Heading';
import Row from 'components/Row';
import SyncSetupView from 'syncSetup/components/SyncSetupView';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';
import TitleHeader from 'components/TitleHeader';
import WizardHeader from 'components/WizardHeader';
import { SyncType } from 'globalTypes';
import ModalTrigger from 'components/ModalTrigger';
// @ts-ignore
import SupportDialog from 'support/components/SupportDialog';

type Props = {
  orgName: string;
  selectSyncType: (method: SyncType) => void;
  onClose: () => void;
  hasClasslinkSupport?: boolean;
};

type State = {
  syncType: SyncType;
};

class AdminSyncTypePickerModal extends React.Component<Props, State> {
  state = {
    syncType: this.props.hasClasslinkSupport ? SyncType.classlink : SyncType.remindSpreadsheetV2,
  };

  renderHeaderWithIcon = () => {
    return (
      <WizardHeader>
        <TextWithIcon
          data-test="sync-type-picker-header-icon"
          icon="arrows-circle-square"
          iconColor="atlas"
          iconSize="large"
          color="chalkboard"
          size="large">
          SIS sync setup
        </TextWithIcon>
        <Buttons>
          <ModalTrigger modal={<SupportDialog />}>
            <Button
              data-test="sync-type-picker-header-icon-help"
              color="paper"
              level="secondary"
              size="xsmall">
              Help
            </Button>
          </ModalTrigger>
          <Button
            data-test="sync-type-picker-header-icon-close"
            eventElementName="SyncTypePicker-close"
            color="paper"
            level="secondary"
            size="xsmall"
            onClick={this.handleHideRequest}>
            Close
          </Button>
        </Buttons>
      </WizardHeader>
    );
  };

  renderHeaderWithoutIcon = () => {
    return (
      <TitleHeader>
        <Text align="right">
          <Button
            data-test="sync-type-picker-header-no-icon-close"
            color="paper"
            level="secondary"
            size="xsmall"
            onClick={this.handleHideRequest}>
            Close
          </Button>
        </Text>
        {this.renderOrgNameTitle()}
      </TitleHeader>
    );
  };

  renderOrgNameTitle = () => {
    const { orgName } = this.props;
    return (
      <React.Fragment>
        <Row size="xxsmall">
          <Text color="graphite" align="left">
            {orgName}
          </Text>
        </Row>
        <Row>
          <Heading levelStyle="1" align="left">
            SIS sync setup
          </Heading>
        </Row>
      </React.Fragment>
    );
  };

  displaySyncType = (syncType: SyncType) => {
    this.setState({ syncType: syncType });
  };

  handleHideRequest = () => {
    this.props.onClose();
  };

  renderDialogWithIconHeader = (body: React.ReactNode) => {
    return (
      <React.Fragment>
        {this.renderHeaderWithIcon()}
        <SyncSetupView>
          <Container className="AdminSyncTypePickerModal" size="large">
            {this.renderOrgNameTitle()}
            {body}
          </Container>
        </SyncSetupView>
      </React.Fragment>
    );
  };

  renderDialogWithHeader = (body: React.ReactNode) => {
    return (
      <Container className="AdminSyncTypePickerModal" size="large">
        {this.renderHeaderWithoutIcon()}
        {body}
      </Container>
    );
  };

  render() {
    const { selectSyncType, onClose } = this.props;
    const currentUser = CurrentUser.getUser();
    const shouldRenderHeaderWithIcon = currentUser.hasFeature(
      'rostering_classlink_support.web.apr-21'
    );

    const body =
      this.state.syncType === SyncType.clever ? (
        <AdminSyncTypeCleverView
          selectSyncType={selectSyncType}
          onClose={onClose}
          displaySyncType={this.displaySyncType}
        />
      ) : (
        <AdminSyncTypeSpreadsheetView
          selectSyncType={selectSyncType}
          onClose={onClose}
          displaySyncType={syncType => this.displaySyncType(syncType)}
          syncType={this.state.syncType}
        />
      );

    return (
      <Dialog box={true} full theme="light">
        {shouldRenderHeaderWithIcon
          ? this.renderDialogWithIconHeader(body)
          : this.renderDialogWithHeader(body)}
      </Dialog>
    );
  }
}

export default AdminSyncTypePickerModal;
